import React from 'react'
import classnames from 'classnames'

import QuestionSingleContainer from './QuestionSingleContainer'
import styles from './QuestionsHorizontal.module.scss'

const QuestionsHorizontal = ({
  className,
  multiline,
  questions,
  questionTopic,
  questionsTitle
}) => (
  <div className={className}>
    <h3 className={styles.title}>{questionsTitle}</h3>
    <div
      className={classnames(
        styles.questionsContainer,
        multiline && styles.multiline
      )}
    >
      {questions.map(({ question, placeholder }, i) => (
        <QuestionSingleContainer
          key={i}
          name={`input_${i}`}
          question={question}
          placeholder={placeholder}
          questionTopic={questionTopic}
        />
      ))}
    </div>
  </div>
)

export default QuestionsHorizontal
